@if (finalUrl) {
@if (finalUrl.fullRedirect) {
<a [ngClass]="className"
   [href]="finalUrl.href"
   [attr.target]="finalUrl.target"
   [attr.aria-label]="hrefAriaLabel">
    <ng-container *ngTemplateOutlet="contentTmpl" />
</a>
} @else {
<a [ngClass]="className"
   [href]="finalUrl.href"
   [attr.target]="finalUrl.target"
   [attr.aria-label]="hrefAriaLabel">
    <ng-container *ngTemplateOutlet="contentTmpl" />
</a>
}
} @else {
@if (finalAction) {
<button [ngClass]="className"
        [attr.aria-label]="hrefAriaLabel">
    <ng-container *ngTemplateOutlet="contentTmpl" />
</button>
} @else {
<ng-container *ngTemplateOutlet="contentTmpl" />
}
}
<ng-template #contentTmpl>
    <ng-content />
</ng-template>